import { JsonPipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  standalone: true,
  imports: [NgClass,MatDialogModule, MatButtonModule, NgIf, JsonPipe,NgTemplateOutlet],

})
export class InfoModalComponent {
  constructor(
    private elementRef: ElementRef,
    public dialogRef: MatDialogRef<InfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
}
